var _rect, _rect2, _text, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _text2, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _text3, _rect14, _polygon, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileTypesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 35,
    height: 45,
    rx: 2,
    ry: 2,
    fill: "#fee2e2",
    stroke: "#dc2626",
    strokeWidth: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 35,
    height: 8,
    rx: 2,
    ry: 2,
    fill: "#dc2626"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32.5,
    y: 31,
    fontFamily: "Arial, sans-serif",
    fontSize: 6,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "PDF")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 25,
    height: 1,
    fill: "#6b7280"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 42,
    width: 20,
    height: 1,
    fill: "#6b7280"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 46,
    width: 28,
    height: 1,
    fill: "#6b7280"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 50,
    width: 15,
    height: 1,
    fill: "#6b7280"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 35,
    height: 45,
    rx: 2,
    ry: 2,
    fill: "#dbeafe",
    stroke: "#2563eb",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 35,
    height: 8,
    rx: 2,
    ry: 2,
    fill: "#2563eb"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 47.5,
    y: 41,
    fontFamily: "Arial, sans-serif",
    fontSize: 5.5,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "DOCX")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 48,
    width: 25,
    height: 1,
    fill: "#6b7280"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 52,
    width: 28,
    height: 1,
    fill: "#6b7280"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 56,
    width: 20,
    height: 1,
    fill: "#6b7280"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 60,
    width: 25,
    height: 1,
    fill: "#6b7280"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 64,
    width: 18,
    height: 1,
    fill: "#6b7280"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 35,
    height: 45,
    rx: 2,
    ry: 2,
    fill: "#ecfdf5",
    stroke: "#059669",
    strokeWidth: 1.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 35,
    height: 8,
    rx: 2,
    ry: 2,
    fill: "#059669"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 62.5,
    y: 51,
    fontFamily: "Arial, sans-serif",
    fontSize: 6,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "IMG")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 58,
    width: 29,
    height: 22,
    rx: 1,
    ry: 1,
    fill: "#f3f4f6",
    stroke: "#d1d5db",
    strokeWidth: 0.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,75 55,68 60,72 65,65 70,70 75,78",
    fill: "#6b7280"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 64,
    r: 2.5,
    fill: "#fbbf24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 48 58 L 52 58 L 48 62 Z",
    fill: "#d1d5db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypesIcon);
export default __webpack_public_path__ + "static/media/file_types_icon.5521f28a839393891e7c5032b1653d2e.svg";
export { ForwardRef as ReactComponent };